const getters = {
  routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js